import { useCallback, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";
import { CAMPOS_COMPENSADA, letraColuna } from "./camposCompensada";

const OPCOES_COLUNA = Array.from({ length: 26 }, (_, i) => i);

function ConfigurarColunasModal({ visible, onHide, service }) {
    const [mapeamento, setMapeamento] = useState({});
    const [loading, setLoading] = useState(false);
    const [salvando, setSalvando] = useState(false);

    const carregarConfig = useCallback(async () => {
        setLoading(true);
        try {
            const res = await service.getColunasConfig();
            setMapeamento(res.data || {});
        } finally {
            setLoading(false);
        }
    }, [service]);

    useEffect(() => {
        if (visible) {
            carregarConfig();
        }
    }, [visible, carregarConfig]);

    const handleChange = (campo, valor) => {
        setMapeamento(prev => ({ ...prev, [campo]: valor === "" ? null : Number(valor) }));
    };

    const handleSalvar = async () => {
        setSalvando(true);
        try {
            await service.salvarColunasConfig(mapeamento);
            toast.success("Mapeamento de colunas salvo com sucesso!");
            onHide();
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Dialog
            header="Configurar Colunas"
            visible={visible}
            onHide={onHide}
            blockScroll
            className="w-[95%] md:w-[500px]"
        >
            <p className="text-sm text-muted-foreground mb-4">
                Defina qual coluna da planilha corresponde a cada campo. Esse mapeamento fica salvo e será
                sugerido automaticamente nas próximas importações.
            </p>

            {loading ? (
                <div className="text-sm text-muted-foreground">Carregando...</div>
            ) : (
                <div className="flex flex-col gap-3">
                    {CAMPOS_COMPENSADA.map(({ campo, label }) => (
                        <div key={campo} className="flex items-center justify-between gap-3">
                            <label className="text-sm text-foreground">{label}</label>
                            <select
                                value={mapeamento[campo] ?? ""}
                                onChange={(e) => handleChange(campo, e.target.value)}
                                className="border border-border rounded-md px-2 py-1.5 text-sm bg-card text-foreground w-40"
                            >
                                <option value="">Selecione...</option>
                                {OPCOES_COLUNA.map(i => (
                                    <option key={i} value={i}>Coluna {letraColuna(i)}</option>
                                ))}
                            </select>
                        </div>
                    ))}
                </div>
            )}

            <div className="flex justify-end gap-2 mt-6 pt-3 border-t border-border">
                <Button label="Cancelar" variant="gray" onClick={onHide} />
                <Button label="Salvar" variant="indigo" loading={salvando} onClick={handleSalvar} />
            </div>
        </Dialog>
    );
}

export default ConfigurarColunasModal;
